import { useState } from 'react'

import { zodResolver } from '@hookform/resolvers/zod'
import { FormProvider, useForm } from 'react-hook-form'

import { QUESTIONNAIRE_FORM_ID, questionnaireFieldsSchema } from '../consts'
import { useQuestionnaireSubmit } from '../hooks/use-questionnaire-submit'
import type { QuestionnaireFormValues } from '../types'
import { BusinessTypeStep } from '../ui/steps/business-type'
import { PersonalInfoStep } from '../ui/steps/personal-info'

export const QuestionnaireView = () => {
  const onSubmit = useQuestionnaireSubmit()
  const [currentStep, setCurrentStep] = useState<'business' | 'personal'>(
    'business',
  )
  const form = useForm<QuestionnaireFormValues>({
    resolver: zodResolver(questionnaireFieldsSchema),
    defaultValues: {
      WhatsApp: '+',
      Telegram: '',
      Email: '',
      socialMedia: '',
      influencer: '',
      blog: '',
      other: '',
    },
  })

  const step =
    currentStep === 'business' ? (
      <BusinessTypeStep onClickNext={() => setCurrentStep('personal')} />
    ) : (
      <PersonalInfoStep onClickBack={() => setCurrentStep('business')} />
    )

  return (
    <div className="relative z-10 m-auto w-full max-w-[768px] overflow-auto no-scrollbar max-h-[calc(100vh-52px)] rounded-2xl border bg-[rgba(255,255,255,0.90)] md:px-14 md:py-12 px-4 py-8 dark:border-secondary-500 dark:bg-[rgba(24,26,34,0.85)] max-md:mt-[52px]">
      <div className="absolute left-0 top-0 z-0 h-[520px] w-[520px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(50%_50%_at_50%_50%,#1E84E3_0%,#FEFEFE_100%)] opacity-30 dark:bg-[radial-gradient(50%_50%_at_50%_50%,#231548_0%,_rgba(22,24,32,0.00)100%)] dark:opacity-100" />
      <FormProvider {...form}>
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          id={QUESTIONNAIRE_FORM_ID}
        >
          {step}
        </form>
      </FormProvider>
    </div>
  )
}
